module.exports = __webpack_public_path__ + "media/images/general/profileAvatar-black-61048235972a9b676a955ba09958bfb8.svg";